import React from 'react'

import './SheetBridgeTruncationWarning.scss'

export type SheetBridgeTruncationWarningProps = {
  message?: string
}

/**
 * SheetBridge row/header truncation notice (from X-SheetBridge-Warnings).
 */
export default function SheetBridgeTruncationWarning({
  message,
}: SheetBridgeTruncationWarningProps): JSX.Element | null {
  if (!message) {
    return null
  }

  return (
    <p className="sheetbridge-truncation-warning">
      <strong>Warning:</strong> {message}
    </p>
  )
}
